// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3lMQB","footer":"ChangeClinic_footer__YgLSh"};